import Excel from "exceljs/dist/es5/exceljs.browser.js";
import _ from "lodash";
import axios from "axios";

const raw_data_cols = [
  { header: "Audit Item Id", key: "auditItemId", width: 32 },
  {
    header: "Audit Item Category",
    key: "auditItemCategory",
    width: 32
  },
  { header: "Audit Item Weight", key: "auditItemWeight", width: 32 },
  { header: "Audit Item Text", key: "auditItemText", width: 32 },
  {
    header: "Finding Weight Best Possible",
    key: "findingWeightBestPossible",
    width: 32
  },
  {
    header: "Finding Weight Worst Possible",
    key: "findingWeightWorstPossible",
    width: 32
  },

  { header: "Finding Id", key: "findingId", width: 32 },
  { header: "Finding Note", key: "findingNote", width: 32 },
  { header: "Finding Weight", key: "findingWeight", width: 32 },
  { header: "Finding Type Id", key: "findingTypeId", width: 32 },
  { header: "Finding Type Name", key: "findingTypeName", width: 32 },
  { header: "Finding Type Abbr", key: "findingTypeAbbr", width: 32 },
  { header: "Finding Type Desc", key: "findingTypeDesc", width: 32 },

  { header: "Measure Id", key: "measureId", width: 32 },
  { header: "Measure Type Id", key: "measureTypeId", width: 32 },
  { header: "Measure Type Name", key: "measureTypeName", width: 32 },
  { header: "Measure Type Abbr", key: "measureTypeAbbr", width: 32 },
  { header: "Measure Type Desc", key: "measureTypeDesc", width: 32 },
  { header: "Measure Note", key: "measureNote", width: 32 },
  { header: "Measure Desc", key: "measureDesc", width: 32 },
  {
    header: "Measure cause_analysis",
    key: "measureCauseAnalysis",
    width: 32
  },
  { header: "Measure due date", key: "measureDueDate", width: 32 },
  {
    header: "Measure assigned to",
    key: "measureAssignedTo",
    width: 32
  },
  {
    header: "Measure create date",
    key: "measureCreateDate",
    width: 32
  },
  { header: "Measure Author", key: "measureAuthor", width: 32 },
  { header: "Measure Status", key: "measureStatus", width: 32 },
  { header: "Measure Priority", key: "measurePriority", width: 32 }
];

const col2XlsCol = colIdx => {
  colIdx = parseInt(colIdx, 10);
  console.assert(colIdx > 0, "colIdx must be 1-based");
  colIdx = colIdx - 1;
  const radix = 26;
  const a_codepoint = "A".codePointAt(0);
  let result = "";
  do {
    const offset = colIdx % radix;
    result = String.fromCodePoint(a_codepoint + offset) + result;
    colIdx = Math.floor((colIdx - offset) / radix) - 1;
  } while (colIdx >= 0);

  return result;
};

const loadTemplate = url => {
  console.log("loadTemplate", url);
  return axios({
    method: "GET",
    url,
    responseType: "arraybuffer"
  }).then(res => {
    if (res.status === 200) {
      const uintArray = new Uint8Array(res.data);

      const workbook = new Excel.Workbook();
      return workbook.xlsx.load(uintArray);
      // return workbook;
      // resolve(response.data);
    } else {
      throw "Download Excel Template failed";
    }
  });
};

const handleDataAuditSheet = async (AuditReportingVueThis, workbook) => {
  console.log("handleDataAuditSheet", AuditReportingVueThis, workbook);
  const audit_sheet = workbook.addWorksheet("DataAudit");
  audit_sheet.getColumn(5).numFmt = "0.00%";

  const audit_data = AuditReportingVueThis.currentExcelExport;

  audit_sheet.addRows(audit_data);
  audit_sheet.state = "veryHidden";
  return workbook;
};
const handleDataSheet = async (flatFindingsList, workbook) => {
  console.log("handleDataSheet", flatFindingsList, workbook);
  // Create Reporting by raw data:
  const raw_data_sheet = workbook.addWorksheet("Data");

  raw_data_sheet.columns = raw_data_cols;
  raw_data_sheet.addRows(flatFindingsList);
  raw_data_sheet.state = "veryHidden";
  return workbook;
};

const handleExportSheet = async (
  flatFindingsList,
  workbook,
  export_sheet_name,
  export_sheet_row_offset,
  export_sheet_cols
) => {
  console.log(
    "handleExportSheet",
    flatFindingsList,
    workbook,
    export_sheet_name
  );

  const raw_data = flatFindingsList;
  const actionlist_sheet = workbook.getWorksheet(export_sheet_name);

  console.log("Length of Data", raw_data.length);

  const getSourceExcelCol = ColKey => {
    const col = raw_data_cols.findIndex(v => v.key == ColKey);
    console.assert(col >= 0, "Known ColKey expected.", ColKey);
    return col2XlsCol(col + 1);
  };
  const source_header_offset = 1;
  const target_row_offset = export_sheet_row_offset;
  const target_col_offset = 0;

  const raw_export_rows = {
    no: rowIdx => rowIdx - source_header_offset,
    auditItemText: rowIdx => {
      const auditItemTextCol = getSourceExcelCol("auditItemText");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${auditItemTextCol}${rowIdx}),"",Data!${auditItemTextCol}${rowIdx})`,
        alignment: { wrapText: true }
      };
    },

    findingNote: rowIdx => {
      const findingNoteCol = getSourceExcelCol("findingNote");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${findingNoteCol}${rowIdx}),"",Data!${findingNoteCol}${rowIdx})`,
        alignment: { wrapText: true }
      };
    },
    findingWeightBestPossible: rowIdx => {
      const findingWeightBestPossibleCol = getSourceExcelCol(
        "findingWeightBestPossible"
      );
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${findingWeightBestPossibleCol}${rowIdx}),"",Data!${findingWeightBestPossibleCol}${rowIdx})`
      };
    },
    findingWeight: rowIdx => {
      const findingWeightCol = getSourceExcelCol("findingWeight");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${findingWeightCol}${rowIdx}),"",Data!${findingWeightCol}${rowIdx})`
      };
    },

    findingTypeAbbr: rowIdx => {
      const findingTypeAbbrCol = getSourceExcelCol("findingTypeAbbr");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${findingTypeAbbrCol}${rowIdx}),"",Data!${findingTypeAbbrCol}${rowIdx})`
      };
    },
    measureCauseAnalysis: rowIdx => {
      const measureCauseAnalysisCol = getSourceExcelCol("measureCauseAnalysis");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${measureCauseAnalysisCol}${rowIdx}),"",Data!${measureCauseAnalysisCol}${rowIdx})`,
        alignment: { wrapText: true }
      };
    },
    measureFullNote: rowIdx => {
      const measureNotesCol = getSourceExcelCol("measureNote");
      const measureDescCol = getSourceExcelCol("measureDesc");
      return {
        result: null,
        formula: `IF(ISBLANK(Data!${measureNotesCol}${rowIdx}),"",Data!${measureNotesCol}${rowIdx})&IF(ISBLANK(Data!${measureDescCol}${rowIdx}),"",IF(ISBLANK(Data!${measureNotesCol}${rowIdx}),"",CHAR(10))&Data!${measureDescCol}${rowIdx})`,
        alignment: { wrapText: true }
      };
    },
    measureTypeAbbr: rowIdx => {
      const measureTypeAbbrCol = getSourceExcelCol("measureTypeAbbr");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${measureTypeAbbrCol}${rowIdx}),"",Data!${measureTypeAbbrCol}${rowIdx})`
      };
    },
    measureAssignedTo: rowIdx => {
      const measureAssignedToCol = getSourceExcelCol("measureAssignedTo");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${measureAssignedToCol}${rowIdx}),"",Data!${measureAssignedToCol}${rowIdx})`,
        alignment: { wrapText: true }
      };
    },
    measureDueDate: rowIdx => {
      const measureDueDateCol = getSourceExcelCol("measureDueDate");
      return {
        result: null,

        formula: `IF(ISBLANK(Data!${measureDueDateCol}${rowIdx}),"",Data!${measureDueDateCol}${rowIdx})`
      };
    }
  };

  const raw_columns_mapping = export_sheet_cols.map(name => {
    if (typeof name === "string" && name in raw_export_rows) {
      return raw_export_rows[name];
    } else {
      console.warn("UNKNOWN COLUMN", name);
      return null;
    }
  });

  for (let row_idx = 1; row_idx <= raw_data.length; row_idx++) {
    const ro = []; //getActionlistRow(i + 2);
    for (const raw_column_mapping of raw_columns_mapping) {
      if (typeof raw_column_mapping === "function") {
        ro.push(raw_column_mapping(row_idx + source_header_offset));
      } else {
        ro.push(raw_column_mapping);
      }
    }

    actionlist_sheet.addRow(ro);
  }
  const autoFilter =
    col2XlsCol(target_col_offset + 1) +
    target_row_offset +
    ":" +
    col2XlsCol(target_col_offset + raw_columns_mapping.length) +
    (target_row_offset + raw_data.length);
  console.log("AutoFilter", autoFilter);
  actionlist_sheet.autoFilter = autoFilter;
  return workbook;
};

const handleTemplateInputSheet = async (AuditReportingVueThis, workbook) => {
  console.log("handleTemplateInputSheet", AuditReportingVueThis, workbook);
  const summary_data = AuditReportingVueThis.currentAuditReportSummary;
  const calc_score = AuditReportingVueThis.currentCalcScore;

  const extractByFinding = (abbr, key) => {
    const finding = summary_data.statistics.byFindingType.find(
      e => e.abbr === abbr
    );
    if (typeof finding !== "undefined" && key in finding) {
      return finding[key];
    } else {
      return 0;
    }
  };

  const co_auditors = _.map(
    summary_data.auditCoAuditors,
    user => user.displayName
  );
  const participants = _.map(
    summary_data.auditParticipants,
    user => user.displayName
  );
  const template_input_values = {
    auditSummary: summary_data.auditSummary,
    countMinorDeviations: extractByFinding("NB", "count"),
    countMajorDeviations: extractByFinding("AB", "count"),
    countImprovement: extractByFinding("VP", "count"),
    currentScore: calc_score.currentScore,
    bestScore: calc_score.bestScore,
    worstScore: calc_score.worstScore,
    invalidScore: calc_score.criteriaNotApplicabelTotalScore,
    participantsList: participants.join(", "),
    participantsML: participants.join("\n"),
    leadAuditor: summary_data.leadAuditor.displayName,
    coAuditorList: co_auditors.join(", "),
    coAuditorML: co_auditors.join("\n"),
    auditDate: _.map(summary_data.auditingDates, date =>
      date.toLocaleDateString()
    ).join(", "),
    auditType: summary_data.auditType || "",
    exportDate: new Date(),
    auditName: summary_data.auditName,
    organisationName: " ",
    processName: " "
  };
  const template_input_sheet = workbook.getWorksheet("TemplateInput");
  const template_input_value_column = template_input_sheet.getColumn("B");
  template_input_value_column.eachCell(cell => {
    if (cell.name in template_input_values) {
      cell.value = template_input_values[cell.name];
    }
  });
  template_input_sheet.state = "veryHidden";
  return workbook;
};

const handleReportSheet = async (workbook, report_sheet_name) => {
  console.log("handleReportSheet", workbook, report_sheet_name);
  // cleanup results so that Excel recalculates the result on load of the workbook
  const report_sheet = workbook.getWorksheet(report_sheet_name);
  if (report_sheet) {
    report_sheet.eachRow(function(row) {
      row.eachCell(function(cell) {
        if (typeof cell.formula !== "undefined") {
          cell.value = { formula: cell.formula, result: null };
        }
      });
    });
  }
  return workbook;
};

const generateXlsxReport = (AuditReportingVueThis, flatFindingsList) => {
  return () => {
    console.log("generateXlsx: Action");
    return new Promise((resolve, reject) => {
      const template_url = AuditReportingVueThis.audit.exportTemplate;
      // const template_url =        "https://firebasestorage.googleapis.com/v0/b/audit-cloud-rehau.appspot.com/o/attachments%2Frehau-qm-reporting-template.v12.xlsx?alt=media&token=5f7587b8-01f3-4635-8ae8-2beeb1f98b7e";
      // const template_url =         "https://firebasestorage.googleapis.com/v0/b/audit-cloud-qlkg.appspot.com/o/attachments%2FTemplateQLKG_V8.xlsx?alt=media&token=2a544643-460b-45c1-bb78-c425c29e9dfd";
      const export_sheet_name = // "Audit-Aktionsplan";
        AuditReportingVueThis.audit.exportSheetName || "Pruefungsbericht";
      const report_sheet_name = // "Audit-Bericht";
        AuditReportingVueThis.audit.exportReportSheetName || "Report";
      const export_sheet_row_offset =
        AuditReportingVueThis.audit.exportSheetOffset || 6;
      const export_sheet_cols =
        AuditReportingVueThis.audit.exportSheetCols || [];
      console.log(
        "Template: ",
        template_url,
        export_sheet_name,
        report_sheet_name
      );
      loadTemplate(template_url)
        .then(workbook => {
          return handleDataAuditSheet(AuditReportingVueThis, workbook);
        })
        .then(workbook => {
          return handleDataSheet(flatFindingsList, workbook);
        })
        .then(workbook => {
          return handleExportSheet(
            flatFindingsList,
            workbook,
            export_sheet_name,
            export_sheet_row_offset,
            export_sheet_cols
          );
        })
        .then(workbook => {
          return handleTemplateInputSheet(AuditReportingVueThis, workbook);
        })
        .then(workbook => {
          return handleReportSheet(workbook, report_sheet_name);
        })
        .then(workbook => workbook.xlsx.writeBuffer())
        .then(data => {
          resolve(
            new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
          );
        })
        .catch(reject);
    });
  };
};

export default generateXlsxReport;
